import {
  CHART_PASTEL_FILLS,
  chartPastelColor,
} from "@sd/constants/ticketStatuses";
import type {
  TrackerReportRowId,
  TrackerReportStatusId,
} from "@sd/lib/trackerReportConstants";
import { TRACKER_REPORT_STATUS_COLUMNS } from "@sd/lib/trackerReportConstants";

/** Tracker-type colors — light pink, blue, teal from pastel palette. */
export const TRACKER_ROW_CHART_COLORS: Record<TrackerReportRowId, string> = {
  bug: CHART_PASTEL_FILLS[0],
  new_requirement: CHART_PASTEL_FILLS[1],
  suggestion: CHART_PASTEL_FILLS[3],
};

/** Status colors — cycles light pastel palette in workflow order. */
export const TRACKER_STATUS_CHART_COLORS = Object.fromEntries(
  TRACKER_REPORT_STATUS_COLUMNS.map((col, index) => [
    col.id,
    chartPastelColor(index),
  ])
) as Record<TrackerReportStatusId, string>;

export const TRACKER_ROW_CHART_CONFIG = {
  bug: { label: "Bug", color: TRACKER_ROW_CHART_COLORS.bug },
  new_requirement: {
    label: "New Requirement",
    color: TRACKER_ROW_CHART_COLORS.new_requirement,
  },
  suggestion: {
    label: "Suggestion",
    color: TRACKER_ROW_CHART_COLORS.suggestion,
  },
} as const;
